import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function PaymentCancel() {
  const navigate = useNavigate();
  const { isAuthenticated } = useSelector((state) => state?.auth);

  // 🧹 Cleanup checkout state ONCE
  useEffect(() => {
    sessionStorage.removeItem('upgrade_intent');
    sessionStorage.removeItem('auto_checkout_done');
    sessionStorage.removeItem('upgrade_modal_open');
    sessionStorage.removeItem('from_upgrade_intent');
  }, []);

  const handleTryAgain = () => {
    if (isAuthenticated) {
      navigate('/app/settings', { replace: true });
    } else {
      navigate('/login', { replace: true });
    }
  };

  const handleBackToApp = () => {
    if (isAuthenticated) {
      navigate('/app', { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.iconCancel}>×</div>

        <h1 style={styles.title}>Payment Cancelled</h1>

        <p style={styles.subtitle}>
          No charges were made.
          <br />
          You can upgrade anytime when you’re ready.
        </p>

        <button style={styles.buttonPrimary} onClick={handleTryAgain}>
          Try Again
        </button>

        <button style={styles.buttonSecondary} onClick={handleBackToApp}>
          Back to App
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#eef1ff',
    padding: 24,
  },
  card: {
    maxWidth: 420,
    width: '100%',
    background: '#ffffff',
    borderRadius: 14,
    padding: '40px 32px',
    textAlign: 'center',
    color: '#0f172a',
    boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
    border: '1px solid #e2e8f0',
  },
  iconCancel: {
    width: 64,
    height: 64,
    margin: '0 auto 20px',
    borderRadius: '50%',
    background: '#fee2e2',
    color: '#b91c1c',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 36,
    fontWeight: 700,
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 10,
  },
  subtitle: {
    fontSize: 15,
    color: '#475569',
    marginBottom: 28,
    lineHeight: 1.6,
  },
  buttonPrimary: {
    width: '100%',
    padding: '12px 16px',
    borderRadius: 10,
    border: 'none',
    fontSize: 15,
    fontWeight: 600,
    background: '#4f46e5',
    color: '#ffffff',
    cursor: 'pointer',
    marginBottom: 12,
  },
  buttonSecondary: {
    width: '100%',
    padding: '12px 16px',
    borderRadius: 10,
    border: '1px solid #c7d2fe',
    fontSize: 14,
    fontWeight: 500,
    background: 'transparent',
    color: '#4f46e5',
    cursor: 'pointer',
  },
};
